module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"global-audience":"Global geographic audience"},"pt":{"global-audience":"Audiência geográfica global"},"es":{"global-audience":"Audiencia geográfica global"}}')
  delete Component.options._Ctor
}
